export default {
  errors: {
    cannotBeBlank: "Ce champ ne peut pas être vide",
    required: "Ce champ est requis",
    somethingWentWrong: "Quelque chose a mal tourné !!!",
  },
  logs: {
    time: "Temps",
    username: "Nom d'utilisateur",
    role: "Rôle",
    terminalID: "ID du terminal",
    moduleAccessed: "Module accédé",
    typeOfAccess: "Type d'accès",
    activityLogDetails: "Détails du journal d'activité",
    userId: "ID utilisateur",
    lastLogin: "Dernière connexion",
    geoAccPoint: "Point d'accès géographique",
    ipAdd: "Adresse IP",
    filesAccessed: "Fichiers accédés",
    funAccessed: "Fonction accédée",
    webUrl: "URL de la page web",
    unsuccAtmp: "Tentative de connexion échouée",
    view: "Voir",
    membershipType: "Type d'adhésion",
  },

  validation: {
    exporterRequired: "Le champ Exportateur est requis",
    importerRequired: "Le champ Importateur est requis",
    portOfOriginRequired: "Le champ Port d'origine est requis",
    containerSizeNumber: "Le champ taille du conteneur doit être un nombre",
    containerCapacityNumber: "Le champ capacité du conteneur doit être un nombre",
  },
}
